/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_Proof_DescInputs */

const en_mk_nav_proof_desc = /** @type {(inputs: Mk_Nav_Proof_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review evidence before marking work done.`)
};

const id_mk_nav_proof_desc = /** @type {(inputs: Mk_Nav_Proof_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tinjau bukti sebelum menandai selesai.`)
};

/**
* | output |
* | --- |
* | "Review evidence before marking work done." |
*
* @param {Mk_Nav_Proof_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_proof_desc = /** @type {((inputs?: Mk_Nav_Proof_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_Proof_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_proof_desc(inputs)
	return en_mk_nav_proof_desc(inputs)
});